// /**
//  * WordPress dependencies
//  */
// import { store, getContext } from "@wordpress/interactivity";

// // view.js
// interface TContext {}

// interface TState {}

// const { state } = store("ncmfse/init_demo", {
// 	state: {} as TState,
// 	actions: {},
// 	callbacks: {
// 		logHandleInit: () => {},
// 	},
// });
